export default "__VITE_ASSET__DrxGsXmy__"